import { createStore } from '@updater-core/lib/store';
import isEqual from 'lodash/isEqual';
import { transformEntityBrandings } from './utils';
import * as selectors from './selectors';

export function createInteractor({ gateway, session }) {
  const { getState, setState, subscribe, connect } = createStore({
    entityBrandings: transformEntityBrandings({}),
  });

  // Keep track of session headers and invite token and if either change refetch
  let currentHeaders = {};
  // eslint-disable-next-line no-underscore-dangle
  let _inviteToken;

  async function fetchSiteBranding(headers, inviteToken) {
    const { entityBrandings, subdomain, branding, journey, disclaimer } =
      (await gateway.fetchSiteBranding(inviteToken, headers)) || {};
    setState({
      entityBrandings: transformEntityBrandings({
        entityBrandings,
        whiteLabel: branding,
      }),
      subdomain,
      disclaimer,
      journey,
    });
  }

  const disconnectSession = session.connect((sessionState) => {
    const isAuthenticated = session.selectors.isAuthenticated(sessionState);
    const headers = isAuthenticated
      ? session.selectors.requestHeaders(sessionState)
      : { app: 'mover' };

    if (!isEqual(headers, currentHeaders)) {
      fetchSiteBranding(headers, _inviteToken);
      currentHeaders = headers;
    }
  });

  return {
    getState,
    connect,
    subscribe,
    actions: {
      setInviteToken: async (inviteToken) => {
        if (_inviteToken !== inviteToken) {
          _inviteToken = inviteToken;
          return fetchSiteBranding(currentHeaders, inviteToken).then(() =>
            getState()
          );
        }

        return getState();
      },
    },
    selectors,
    destroy() {
      disconnectSession();
    },
  };
}
